import _ from 'lodash';

class Maps extends L.Class {
    constructor(container, options, callback) {
        super();
        this.world = new Map();
        this.callback = callback;
        if (container && options) this.add(container, options);

        this.onDragEnd = this.onDragEnd.bind(this);

        return this;
    }

    get id() {
        return this.active._id;
    }

    addControl(control) {
        try {
            this.active.addControl(control);
        } catch (err) {
            console.log(err);
        }
    }

    addLayer(layer) {
        try {
            this.active.addLayer(layer);
        } catch (err) {
            console.log(err);
        }
    }

    clearlayers() {
        try {
            this.active.clearlayers();
        } catch (err) {
            console.log(err);
        }
    }

    eachMap(callback) {
        this.world.forEach(m => callback(m));
    }

    eachLayer(callback) {
        this.active.eachLayer(callback);
    }

    fitBounds(bounds) {
        this.active.fitBounds(bounds);
    }

    getCenter() {
        return this.active.getCenter();
    }

    getBounds() {
        return this.active.getBounds();
    }

    getContainer() {
        return this.active.getContainer();
    }

    getPanes() {
        return this.active.getPanes();
    }

    getZoom() {
        return this.active.getZoom();
    }

    hasLayer(layer) {
        return this.active.hasLayer(layer);
    }

    latLngToLayerPoint(latLng) {
        return this.active.latLngToLayerPoint(latLng);
    }

    layerPointToLatLng(point) {
        return this.active.layerPointToLatLng(point);
    }

    off(event, callback) {
        this.active.off(event, callback);
    }

    once(event, callback) {
        this.active.once(event, callback);
    }

    on(event, callback) {
        this.active.on(event, callback);
    }

    fire(event) {
        this.active.fire(event);
    }

    panTo(latLng) {
        this.active.panTo(latLng);
    }

    zoomIn() {
        this.active.zoomIn();
    }

    zoomOut() {
        this.active.zoomOut();
    }

    invalidateSize() {
        this.refresh();
    }

    refresh() {
        this.world.forEach(map => {
            map.invalidateSize();
        });
    }

    removeControl(control) {
        try {
            this.active.removeControl(control);
        } catch (err) {
            console.log(err);
        }
    }

    removeLayer(layer) {
        try {
            this.active.removeLayer(layer);
        } catch (err) {
            console.log(err);
        }
    }

    setView(latlng, zoom) {
        this.active.setView(latlng, zoom);
    }

    setZoom(value) {
        this.active.setZoom(value);
    }

    onDragEnd(e) {
        this.world.forEach(map => {
            if (e.target._id !== map._id) {
                map.fire('zoomend');
            }
        });
    }

    addButton(map) {
        L.easyButton(
            'fa-crosshairs',
            () => {
                this.set(map._id);
            },
            { position: 'topright' }
        ).addTo(map);
    }

    add(container, options = {}) {
        this.unsync();
        const id = this.generateId();
        const map = L.map(container, options);
        map._id = id;
        this.world.set(id, map);
        this.set(id);
        this.addButton(this.get(id));
        this.on('dragend', this.onDragEnd);
        this.sync();
        return this;
    }

    remove(id) {
        this.unsync();
        const map = this.get(id);
        if (map) {
            const container = map.getContainer();
            map.remove();
            $(container).remove();
        }
        this.world.delete(id);
        this.set(this.generateId());
        this.sync();
        return this;
    }

    set(id) {
        this.active = null;

        this.world.forEach((val, key) => {
            if (key === id) this.active = val;
        });

        if (!this.active) {
            this.active = this.world.values().next().value;
        }

        this.refresh();

        if (_.isFunction(this.callback)) {
            this.callback(this.active);
        }
    }

    size() {
        return this.world.size;
    }

    generateId() {
        let id = 0;
        const container = new Map();
        this.world.forEach(map => {
            const _id = id++;
            map._id = _id;
            container.set(_id, map);
        });
        this.world = container;
        return id;
    }

    get(id) {
        if (_.isNumber(id)) {
            return this.world.get(id);
        }
        return this.active;
    }

    next() {
        const id = this.active._id + 1;
        this.set(id % this.size());
    }

    sync() {
        this.world.forEach((oMap, oId) => {
            this.world.forEach((iMap, iId) => {
                if (oId !== iId) oMap.sync(iMap);
            });
        });
    }

    unsync() {
        this.world.forEach((oMap, oId) => {
            this.world.forEach((iMap, iId) => {
                if (oId !== iId) oMap.unsync(iMap);
            });
        });
    }
}

export default Maps;



// WEBPACK FOOTER //
// ./src/scripts/layers/Leaflet/Maps.js